import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import KinnectLandingPage from './KinnectLandingPage';

const KinnectConfirmationPage = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const isVerified = searchParams.get('verified') === 'true';

  return (
    <KinnectLandingPage>
      {isVerified ? (
        <Box sx={{ marginTop: 2.5, paddingX: 5 }}>
          <Typography sx={{ fontFamily: 'EdmondsansMedium' }}>
            Your email has been successfully verified.
          </Typography>
          <Typography sx={{ fontFamily: 'EdmondsansMedium' }}>
            You can now close this window and proceed to the app.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ paddingX: 5 }}>
          <Typography sx={{ fontFamily: 'EdmondsansMedium' }}>
            The verification link is invalid or has expired.
          </Typography>
          <Typography sx={{ fontFamily: 'EdmondsansMedium' }}>
            Please try registering again or contact support at
            kinnectnow@gmail.com.
          </Typography>
        </Box>
      )}
    </KinnectLandingPage>
  );
};

export default KinnectConfirmationPage;
